import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
`;

export const ModalHeader = styled.div`
  padding: 20px 24px 0 24px;
  border-bottom: 1px solid #e9ecef;
  
  h3 {
    margin: 0 0 16px 0;
    color: #333;
    font-size: 1.25rem;
    font-weight: 600;
  }
`;

export const ModalBody = styled.div`
  padding: 20px 24px;
  
  p {
    margin: 0;
    color: #555;
    font-size: 1rem;
    line-height: 1.5;
  }
`;

export const ModalFooter = styled.div`
  padding: 0 24px 24px 24px;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;
`;

export const CancelButton = styled.button`
  padding: 10px 20px;
  border: 1px solid #6c757d;
  background-color: #fff;
  color: #6c757d;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background-color: #6c757d;
    color: #fff;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(108, 117, 125, 0.25);
  }
`;

export const ConfirmButton = styled.button`
  padding: 10px 20px;
  border: 1px solid ${props => props.color || '#1a1a1a'};
  background-color: ${props => props.color || '#1a1a1a'};
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${props => props.color === '#595959' ? '#404040' : '#2f2f2f'};
    border-color: ${props => props.color === '#595959' ? '#404040' : '#2f2f2f'};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${props => props.color === '#595959' ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.25)'};
  }
`;